/**
 * Copyright IBM Corp. 2022, 2026
 */

import React, { useState } from 'react'
import sendPosthogEvent from '@web/utils/send-posthog-event'
import Form from 'components/marketo-form'
import s from './style.module.css'

interface Props {
	product: string[]
	title: string
	webinarId?: string
	marketoFormId: number
	onSubmitSuccess: () => void
}

export default function GatedWebinarMarketoForm({
	product,
	title,
	webinarId,
	marketoFormId,
	onSubmitSuccess,
}: Props) {
	const [globalError, setGlobalError] = useState(null)

	return (
		<section className={s.container}>
			<h4 className={s.heading}>Watch the recorded webinar</h4>
			<Form
				formName="Watch the recorded webinar"
				formId={marketoFormId.toString()}
				initialValues={
					webinarId ? { registeredWebinarID: webinarId } : undefined
				}
				onSubmitSuccess={() => {
					sendPosthogEvent('Webinar Signed Up', {
						...(product?.length && { product: product[0] }),
						title: title,
						webinar_id: webinarId,
						sales_contact_requested: false,
					})

					onSubmitSuccess()
				}}
				onSubmitError={() => {
					setGlobalError(
						'Unfortunately something went wrong. Please try again later.',
					)
				}}
			/>
			{globalError && (
				<div className="global-error g-type-body-small error">
					{globalError}
				</div>
			)}
		</section>
	)
}
